import { render, staticRenderFns } from "./ItemsAddListing.vue?vue&type=template&id=72832134&"
import script from "./ItemsAddListing.vue?vue&type=script&lang=js&"
export * from "./ItemsAddListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports